import axios from "@/axios";
import Util from "../../../../util/util";
import moment from "moment";

export const namespaced = true;
let options = {
    'Content-Type': 'application/json'
};
const DefaultInvoiceInformationData = {
  orderId: 0,
  invoiceNumber: ''
};

export const state = {
    invocieInformation: {
        orderId: DefaultInvoiceInformationData.orderId,
        invoiceNumber: DefaultInvoiceInformationData.invoiceNumber,
    },
    status: true
}

export const getters = {
    invoiceInformation: (state)=> {
        return state.invocieInformation;
    },
    invoiceStatus: (state)=> {
        return state.status;
    }
}

export const actions = {
    async loadInvoiceInformation({commit}, orderId) {
        try{
            let url = `/api/financeinformation/invoice/${orderId}`;
            let ret = await axios.get(url, options);
            commit('SetInvoiceNumber', ret.data);
        } catch(err) {
            return error.response.data.error;
        }        
    },
    async saveInvoiceNumber({commit, state, dispatch}, orderId) {
        try {
            state.invocieInformation.orderId = orderId;
            let url = `/api/financeinformation/invoice`;
            let ret = await axios.post(url, state.invocieInformation, options);
            await dispatch("loadInvoiceInformation", orderId);
            return;
        } catch(error) {
            return error.response.data.error;
        }
      
    }
}

const mutations = {
    SetInvoiceNumber: (state, data) => {
        let d = {...state.invocieInformation};
        d.invoiceNumber = data.invoiceNumber;
        d.orderId = data.orderId;
        state.invocieInformation = Object.assign(d, {});
    }
}

export default {
    state,
    actions,
    getters,
    mutations,
    namespaced
}